import { RiskPermission } from '@core/models/risk-permission.model';
import { StaticPermission } from '@core/models/static-permission.model';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as PermissionActions from './permissions.action';
import { ActionPermission } from '@core/models/action-permission.model';
import { ServicePermission } from '@core/models/service-permission.model';
import { InterplanPermission } from '@core/models/interplan-permission.model';

export interface PermissionsFeatureState {
    staticPermissions: StaticPermission;
    riskPermissions: RiskPermission;
    actionPermissions: ActionPermission;
    servicePermissions: ServicePermission;
    interplanPermissions: InterplanPermission;
}

export const initialState: PermissionsFeatureState = {
    staticPermissions: {
        riskTypes: [],
        staticAbilities: {},
        riskRegisterIds: [],
    },
    riskPermissions: {
        assignedPermission: {
            isRO: false,
            isSRO: false,
            isConfidentialStaff: false,
        },
        riskAbilities: {},
        approvalAssignedPermission: {
            isNextApprover: false,
            isNextRejector: false,
            isPreparer: false,
            isReSubmitter: false,
            isSubmitter: false,
            isPreviousApprover: false,
            isPreviousRejector: false,
        },
    },
    actionPermissions: {
        actionAbilities: {},
        actionRoAbilities: {},
    },
    servicePermissions: {
        coreDataAbilities: {},
    },
    interplanPermissions: {
        interplanAbilities: {},
    },
};

export const permissionsFeature = createFeature({
    name: 'permissions',
    reducer: createReducer(
        initialState,
        on(PermissionActions.setStaticPermissions, (state, data) => ({
            ...state,
            staticPermissions: data.staticPermissions,
        })),
        on(PermissionActions.resetStaticPermissions, (state) => ({
            ...state,
            staticPermissions: initialState.staticPermissions,
        })),
        on(PermissionActions.setRiskPermissions, (state, data) => ({
            ...state,
            riskPermissions: data.riskPermissions,
        })),
        on(PermissionActions.resetRiskPermissions, (state) => ({
            ...state,
            riskPermissions: initialState.riskPermissions,
        })),
        on(PermissionActions.setActionPermissions, (state, data) => ({
            ...state,
            actionPermissions: data.actionPermissions,
        })),
        on(PermissionActions.resetActionPermissions, (state) => ({
            ...state,
            actionPermissions: initialState.actionPermissions,
        })),
        on(PermissionActions.setServicePermissions, (state, data) => ({
            ...state,
            servicePermissions: data.servicePermissions,
        })),
        on(PermissionActions.resetServicePermissions, (state) => ({
            ...state,
            servicePermissions: initialState.servicePermissions,
        })),
        on(PermissionActions.setInterplanPermissions, (state, data) => ({
            ...state,
            interplanPermissions: data.interplanPermissions,
        })),
        on(PermissionActions.resetInterplanPermissions, (state) => ({
            ...state,
            interplanPermissions: initialState.interplanPermissions,
        })),
    ),
});

export const {
    name, // feature name
    reducer, // feature reducer
    selectPermissionsState, // feature selector
    selectStaticPermissions, // selector for `static` property
    selectRiskPermissions, // selector for `risk` property
    selectActionPermissions,
    selectServicePermissions,
    selectInterplanPermissions,
} = permissionsFeature;
